(function (root) {
  'use strict';
  function variantState(variants, id) {
    if (!id) return null;
    const variant = variants.find(item => String(item.id) === String(id));
    return variant ? {...variant, label: variant.title.replace(/2\s+XL/g, '2XL')} : null;
  }
  function searchQuery(text) {
    return ['vendor:"Golden Mask Wear"', String(text || '').trim()].filter(Boolean).join(' ');
  }
  function filterPath(base, tags) {
    const safe = tags.filter(tag => /^[a-z0-9-]+$/.test(tag));
    return base.replace(/\/$/, '') + (safe.length ? '/' + safe.join('+') : '');
  }
  function withdrawalText(data) {
    return 'Je vous notifie ma rétractation du contrat portant sur la commande ' + data.order + '.\n' +
      'Articles concernés : ' + (data.items || 'La totalité de la commande') + '\n' +
      'Nom et prénom : ' + data.name + '\nCourriel pour l’accusé de réception : ' + data.email +
      '\nDéclaration confirmée le : ' + data.time;
  }
  const api = {variantState, searchQuery, withdrawalText, filterPath};
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  if (typeof document === 'undefined') return;
  root.GMWear = api;
  function setup(scope) {
    scope.querySelectorAll('[data-wear-tag-form]').forEach(form => {
      if (form.dataset.ready) return;
      form.dataset.ready = 'true';
      form.addEventListener('submit', () => {
        form.action = filterPath(form.dataset.collectionUrl, [...form.querySelectorAll('[data-wear-tag]')].map(select => select.value).filter(Boolean));
      });
    });
    scope.querySelectorAll('[data-wear-search-form]').forEach(form => {
      if (form.dataset.ready) return;
      form.dataset.ready = 'true';
      form.addEventListener('submit', () => { const input = form.querySelector('[name="q"]'); input.value = searchQuery(input.value); });
    });
    scope.querySelectorAll('[data-wear-product]').forEach(product => {
      if (product.dataset.ready) return;
      product.dataset.ready = 'true';
      const variants = JSON.parse(product.querySelector('[data-wear-variants]').textContent);
      const select = product.querySelector('[data-wear-variant]');
      const price = product.querySelector('[data-wear-price]');
      const buy = product.querySelector('[data-wear-buy]');
      const label = product.querySelector('[data-wear-selection]');
      const selectionPrompt = product.dataset.unavailableLabel || product.dataset.chooseLabel;
      const gallery = product.querySelector('[data-wear-main-image]');
      const chips = product.querySelector('[data-wear-sizes]');
      const thumbnails = [...product.querySelectorAll('[data-wear-image]')];
      const showImage = thumb => {
        gallery.src = thumb.dataset.src;
        gallery.srcset = thumb.dataset.srcset || '';
        gallery.alt = thumb.dataset.alt;
        thumbnails.forEach(item => item.setAttribute('aria-pressed', String(item === thumb)));
      };
      thumbnails.forEach(thumb => thumb.addEventListener('click', () => showImage(thumb)));
      const update = () => {
        const variant = variantState(variants, select.value);
        if (variant) {
          price.textContent = new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', {style:'currency',currency:product.dataset.currency}).format(variant.price / 100);
          buy.disabled = !variant.available;
          buy.textContent = variant.available ? product.dataset.addLabel : product.dataset.soldLabel;
          label.textContent = variant.label;
          const url = new URL(location.href); url.searchParams.set('variant', variant.id); history.replaceState({}, '', url);
          const thumb = thumbnails.find(item => String(item.dataset.imageId) === String(variant.featured_image?.id));
          if (thumb) showImage(thumb);
        } else {
          const available = variants.some(item => item.available);
          buy.disabled = !available;
          buy.textContent = available ? product.dataset.addLabel : product.dataset.soldLabel;
          label.textContent = available ? selectionPrompt : product.dataset.soldLabel;
        }
        chips?.querySelectorAll('button').forEach(item => item.setAttribute('aria-pressed', String(item.dataset.variant === select.value)));
      };
      if (chips && product.dataset.singleOption === 'true') {
        variants.forEach(variant => {
          const button = document.createElement('button'); button.type = 'button';
          button.textContent = variantState(variants, variant.id).label;
          button.dataset.variant = String(variant.id); button.disabled = !variant.available;
          button.addEventListener('click', () => {select.value = String(variant.id);select.dispatchEvent(new Event('change',{bubbles:true}));});
          chips.append(button);
        });
        chips.hidden = false; select.classList.add('gw-visually-hidden'); select.tabIndex = -1;
      }
      select.addEventListener('change', update);
      select.addEventListener('invalid', () => {
        if (chips && !chips.hidden) { label.textContent = selectionPrompt; chips.querySelector('button:not(:disabled)')?.focus(); }
      });
      product.querySelector('[data-wear-product-form]').addEventListener('submit', event => {
        if (!select.value) {event.preventDefault(); label.textContent = selectionPrompt; chips?.querySelector('button:not(:disabled)')?.focus();}
      });
      update();
    });
    scope.querySelectorAll('[data-wear-withdrawal]').forEach(form => {
      if (form.dataset.ready) return;
      form.dataset.ready = 'true';
      const submit = form.querySelector('[data-withdraw-confirm]');
      const review = form.querySelector('[data-withdraw-review]');
      if (!submit || !review) return;
      form.addEventListener('submit', event => {
        const data = {name:form.querySelector('[name="contact[name]"]').value.trim(),email:form.querySelector('[name="contact[email]"]').value.trim(),order:form.querySelector('[name="contact[Commande]"]').value.trim(),items:form.querySelector('[name="contact[Articles]"]').value.trim(),time:new Date().toISOString()};
        const body = form.querySelector('[name="contact[body]"]');
        body.value = withdrawalText(data);
        form.querySelector('[name="contact[Horodatage]"]').value = 'Heure déclarée par le navigateur : ' + data.time;
        if (form.dataset.confirmed !== 'true') {
          event.preventDefault();
          review.querySelector('pre').textContent = body.value;
          review.hidden = false;review.focus();
          submit.textContent = form.dataset.confirmLabel;
          form.dataset.confirmed = 'true';
        }
      });
      form.addEventListener('input', () => {form.dataset.confirmed = 'false';review.hidden=true;submit.textContent=form.dataset.reviewLabel;});
      submit.textContent = form.dataset.reviewLabel;
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => setup(document)); else setup(document);
  document.addEventListener('shopify:section:load', event => setup(event.target));
})(typeof window === 'undefined' ? globalThis : window);
